import React from 'react';
import { Building, Calendar } from 'lucide-react';

const ServiceRequestsPanel = ({ serviceRequests, getPriorityColor, onSubmitProposal }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-900">Available Service Requests</h2>
      </div>
      <div className="divide-y divide-gray-200 max-h-96 overflow-y-auto">
        {serviceRequests.filter(request => request.status === 'Open').map((request) => (
          <div key={request.id} className="p-6">
            <div className="flex items-start justify-between mb-3">
              <h3 className="text-lg font-medium text-gray-900">
                {request.title}
              </h3>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(request.priority)}`}>
                {request.priority}
              </span>
            </div>

            <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
              <div className="flex items-center gap-1">
                <Building className="h-4 w-4" />
                {request.property}
              </div>
              <div className="flex items-center gap-1">
                <Calendar className="h-4 w-4" />
                Due: {request.deadline}
              </div>
            </div>

            <p className="text-gray-700 mb-3">{request.description}</p>

            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Budget Range</p>
                <p className="font-semibold text-green-600">{request.budget}</p>
              </div>
              <button
                onClick={() => onSubmitProposal(request.id)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Submit Proposal
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceRequestsPanel;
